import { NamingConvention } from "namirasoft-core";
import { NSBaseMetaTable } from "./NSBaseMetaTable";

export class NSBaseMetaTable_Frontend
{
    private table: NSBaseMetaTable<any, any>;
    private base: string;
    constructor(table: NSBaseMetaTable<any, any>, name: string)
    {
        this.table = table;
        this.base = NamingConvention.lower_case_underscore.convert(name, NamingConvention.lower_case_slash)
    }
    public getBaseLink(): string
    {
        return this.table.database.product.link + "/" + this.base;
    }
    public getListLink(): string
    {
        return this.getBaseLink() + "/list";
    }
    public getNewLink(): string
    {
        return this.getBaseLink() + "/new";
    }
    public getViewLink(id: string): string
    {
        return this.getBaseLink() + "/" + id + "/view";
    }
    public getUpdateLink(id: string): string
    {
        return this.getBaseLink() + "/" + id + "/edit";
    }
};